import { render, staticRenderFns } from "./HomeClaimsInPast5Years.vue?vue&type=template&id=0183dbcc&"
import script from "./HomeClaimsInPast5Years.vue?vue&type=script&lang=js&"
export * from "./HomeClaimsInPast5Years.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports